"use client";

import React, {useEffect, useRef, useState} from "react";
import Link from "next/link";

import {useDispatch, useSelector} from "react-redux";
import {
    addVehicles,
    resetParcoVeicoli,
    setCount,
    setFilters,
    setHasMore,
    setPage,
    setVehicles,
} from "@/redux/parcoVeicoliSlice";
import {RootState} from "@/redux/store";
import ProductCard from "@/components/test/ProductCard";
import ProductCartNoleggio from "@/components/ProductCartNoleggio";


export default function InfiniteScroll({
                                           initialVehicles,
                                           initialCount,
                                           filters,
                                           pageSize,
                                           tipoListino,
                                           ItemComponent,
    typeSearch
                                       }: {
    initialVehicles: any[];
    initialCount: number;
    filters: string
    pageSize: number;
    tipoListino: string;
    ItemComponent: React.ComponentType<{ product: any }>;
    typeSearch: string;
}) {

    const dispatch = useDispatch();
    const { vehicles, count, page, hasMore } = useSelector(
        (state: RootState) => state.parcoVeicoli
    );
    const [loading, setLoading] = useState(false);
    const parsedFilters = JSON.parse(filters);

    const prevFilters = useRef(filters);

    const currentFilters = useSelector((state: RootState) => state.parcoVeicoli.filters);

    useEffect(() => {
        console.log("Redux state:", { vehicles, count, page, hasMore });
    }, [vehicles, count, page, hasMore]);

    useEffect(() => {
        // Ottieni i filtri salvati in Redux

        // Controlla se i filtri sono cambiati
        const filtersChanged = JSON.stringify(currentFilters) !== JSON.stringify(parsedFilters);

        if (filtersChanged) {
            console.log("Filters changed, updating Redux...");
            // Salva i nuovi filtri in Redux
            dispatch(setFilters(parsedFilters));

            // Resetta Redux e carica i nuovi veicoli
            dispatch(resetParcoVeicoli());
            dispatch(setVehicles(initialVehicles));
            dispatch(setCount(initialCount));
            dispatch(setPage(1));
            dispatch(setHasMore(initialVehicles.length < initialCount));
        } else if (vehicles.length === 0 && page === 1) {
            console.log("First load, loading vehicles...");
            dispatch(setVehicles(initialVehicles));
            dispatch(setCount(initialCount));
            dispatch(setPage(1));
            dispatch(setHasMore(initialVehicles.length < initialCount));
        }
    }, [dispatch, parsedFilters, initialVehicles, initialCount, vehicles.length, page]);


    useEffect(() => {
        console.log("Current filters in Redux:", currentFilters);
        console.log("New filters:", parsedFilters);
    }, [currentFilters, parsedFilters]);


    const loadMore = async () => {
        if (loading || !hasMore) return;
        setLoading(true);

        try {
            const query = new URLSearchParams({
                ...parsedFilters,
                order: parsedFilters.order || "prezzo_DESC",
                page: (page + 1).toString(),
                pageSize: pageSize.toString(),
                tipoUtenteListino: tipoListino,
                typeSearch: typeSearch,
            }).toString();

            console.debug("Fetching data with query:", query);

            const res = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/api/articoli/lista-veicoli?${query}`);
            const data = await res.json();
            console.log("Data fetched:", data.data.length);

            dispatch(addVehicles(data.data));
            dispatch(setPage(page + 1));
            dispatch(setHasMore(data.data.length > 0));
        } catch (error) {
            console.error("Error loading more vehicles:", error);
        } finally {
            setLoading(false);
        }
    };


    // Trigger per caricare più dati quando l'utente scorre verso il fondo
    useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.scrollY + window.innerHeight;
            const documentHeight = document.documentElement.scrollHeight;
            const triggerPoint = documentHeight * 0.3; // 30% della pagina

            if (scrollPosition >= triggerPoint) {
                if (!loading && hasMore) {
                    console.log("30% della pagina raggiunto, caricamento anticipato...");
                    loadMore();
                }
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [loading, hasMore, page, dispatch]);


    return (
        <div>
            <div
                className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 gap-4 sm:gap-4 xl:gap-4 mb-10">
                {vehicles.map((vehicle: any, index) => (
                    typeSearch === 'vendita' ? (
                        vehicle.tipoOfferta === 'noleggio' ? (
                            <ProductCartNoleggio key={index} product={vehicle} showBadge={true} />
                        ) : (
                            <ProductCard key={index} product={vehicle} />
                        )
                    ) : (
                        <ItemComponent key={index} product={vehicle} />
                    )
                ))}
            </div>
            {loading && <div>Caricamento...</div>}
            {!hasMore &&
                <div className="bg-gray-100 flex flex-col md:flex-row items-center p-6 rounded-lg shadow-lg">
                    <div className="flex-shrink-0">
                        <svg
                            width="75"
                            height="65"
                            viewBox="0 0 75 65"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="text-gray-700"
                        >
                            <path d="M37.42 1.93945V10.4795" stroke="black" strokeWidth="2" strokeMiterlimit="10"
                                  strokeLinecap="round"/>
                            <path d="M73.84 38.3594H65.3" stroke="black" strokeWidth="2" strokeMiterlimit="10"
                                  strokeLinecap="round"/>
                            <path d="M9.54 38.3594H1" stroke="black" strokeWidth="2" strokeMiterlimit="10"
                                  strokeLinecap="round"/>
                            <path d="M63.17 12.6094L57.14 18.6394" stroke="black" strokeWidth="2" strokeMiterlimit="10"
                                  strokeLinecap="round"/>
                            <path d="M17.71 18.6394L11.67 12.6094" stroke="black" strokeWidth="2" strokeMiterlimit="10"
                                  strokeLinecap="round"/>
                            <path
                                d="M37.42 56.8699C46.8751 56.8699 54.54 49.205 54.54 39.7499C54.54 30.2948 46.8751 22.6299 37.42 22.6299C27.9649 22.6299 20.3 30.2948 20.3 39.7499C20.3 49.205 27.9649 56.8699 37.42 56.8699Z"
                                stroke="black"
                                strokeWidth="2"
                                strokeMiterlimit="10"
                                strokeLinecap="round"
                            />
                            <path d="M61.53 63.8594L49.52 51.8594" stroke="black" strokeWidth="2" strokeMiterlimit="10"
                                  strokeLinecap="round"/>
                            <path
                                d="M43.98 42.8096V45.4496C43.98 45.7496 43.74 45.9996 43.43 45.9996H40.79C40.49 45.9996 40.24 45.7596 40.24 45.4496V42.8096H43.98Z"
                                stroke="black"
                                strokeWidth="2"
                                strokeMiterlimit="10"
                                strokeLinecap="round"
                            />
                            <path
                                d="M34.59 42.8096V45.4496C34.59 45.7496 34.35 45.9996 34.04 45.9996H31.4C31.1 45.9996 30.85 45.7596 30.85 45.4496V42.8096H34.59Z"
                                stroke="black"
                                strokeWidth="2"
                                strokeMiterlimit="10"
                                strokeLinecap="round"
                            />
                            <path d="M29.76 38.4395H45.08" stroke="black" strokeWidth="2" strokeMiterlimit="10"
                                  strokeLinecap="round"/>
                            <path
                                d="M43.98 38.4298L41.94 33.8298C41.85 33.6298 41.66 33.5098 41.44 33.5098H33.4C33.18 33.5098 32.99 33.6398 32.9 33.8298L30.86 38.4298V42.8098H43.99V38.4298H43.98Z"
                                stroke="black"
                                strokeWidth="2"
                                strokeMiterlimit="10"
                                strokeLinecap="round"
                            />
                        </svg>
                    </div>

                    <div className="flex flex-col justify-center text-center md:text-left md:ml-6 mt-4 md:mt-0">
                        <h3 className="text-2xl font-semibold text-gray-800">Non hai trovato l'auto che cercavi?</h3>
                        <p className="text-gray-600 mt-2">
                            La cerchiamo noi per te. Contattaci indicando le specifiche dell'auto che desideri.
                        </p>
                    </div>

                    <div className="mt-4 md:mt-0 md:ml-auto">
                        <Link href="/richiesta-veicolo" hrefLang="it" title={"Richiesta veicolo"}
                            className="bg-primary text-white font-medium py-4 px-6 rounded-lg hover:bg-primary/80 transition">
                            Invia richiesta
                        </Link>
                    </div>
                </div>

            }
        </div>
    );
}
